
<app-tablelayout [data]="students" [filterItems]="filterOptions" [count]="count" [columnsToRemove]="removeColumn" [offset]="25" 
    (loadDataEvent)="loadTableData($event)"><app-tablelayout/>